<template>
  <div>

    <el-dialog
      :title="data.Baslik"
      :visible="BinaYeniToplantiModal"
      center
      :width="data.id?'60%':'30%'">
      <a @click="$emit('BinaYeniToplantiModal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-row :gutter="24">
        <el-col :span="data.id?18:24">
          <el-form :model="data" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">

            <el-form-item label="Toplantı Konusu" prop="Konu">
              <el-input v-model="data.Konu"></el-input>
            </el-form-item>
            <el-form-item label="Toplantı Tarihi ve Saati" prop="tTarihi">
              <el-date-picker
                v-model="data.tTarihi"
                type="datetime"
                format="dd.MM.yyyy HH:mm"
                default-time="12:00:00"
                placeholder="Tarih ve Saat Seçiniz">
              </el-date-picker>
            </el-form-item>
            <el-form-item v-if="data.id" label="Toplantıya Katılan Kişiler" prop="Kisiler">
              <el-cascader
                collapse-tags
                :options="Kisiler"
                v-model="data.Kisiler"
                :props="{ multiple: true }"
                filterable></el-cascader>
            </el-form-item>

          </el-form>
        </el-col>
        <el-col :span="6" v-if="data.id">
          <Notlar v-if="Notlar" :data="Notlar"></Notlar>
        </el-col>

      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()" icon="el-icon-check">
          {{data.id?'Toplantıyı Güncelle':'Toplantıyı Planla'}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Notlar from "../../../../Genel/Notlar";

  export default {
    components: {Notlar},
    props: ['BinaYeniToplantiModal', 'data'],
    data() {
      return {
        Notlar: null,
        Kisiler: null,
        FormHata: {
          tTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Konu: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            if (this.data.id) {
              this.$store.dispatch("Put", {...this.data, path: 'yonetim/bina/toplanti/' + this.data.id})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.$emit("BinaYeniToplantiModal", false);
                    this.$message.success(response.Mesaj);
                    //this.$router.push('/yonetim/bina')
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            } else {

              this.$store.dispatch("Post", {...this.data, path: 'yonetim/bina/toplanti'})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.$emit("BinaYeniToplantiModal", false);
                    this.$message.success(response.Mesaj);
                    //this.$router.push('/yonetim/bina')
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });
      },
      NotConfig() {
        if (this.data.id) {
          this.Notlar = {
            Modul: 'Toplanti',
            Modul_id: this.data.id
          }
        }
      },
      SayfaYukle() {

        this.$store.dispatch("Get", {path: 'yonetim/kisi/liste/b/' + this.data.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kisiler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
      this.NotConfig();
    },
    computed: {
      rSAyfaYukle() {
        return this.BinaYeniToplantiModal
      },
    },
    watch: {
      rSAyfaYukle() {
        this.NotConfig();
      },
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/Toplanti/BinaYeniToplanti.vue